var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 57,
    viewBox: "0 0 385 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.473777 37.7709V0.473777H353.809L383.854 20.3391V56.1929H155.035H26.6554L0.473777 37.7709Z",
    fill: "url(#paint0_radial_252_435)",
    stroke: "#F342FF",
    strokeWidth: 0.947554
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_252_435",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.132 28.2636) scale(156.318 40.8246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45329C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#090040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputBorder);
export default __webpack_public_path__ + "static/media/inputBorder.3b458d1fb9e3daafe758a66d338fd10d.svg";
export { ForwardRef as ReactComponent };